import React, { useState,useEffect } from "react";
import "./ThankYou.css";
import { useLocation, useNavigate,Link } from "react-router-dom";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';

const ThankYou = () => {
  const [loading,setLoading] = useState(true);
  const navigate = useNavigate();

  const location = useLocation();

  const [inputs,setInputs] = useState({id:'',order_number:'',name:'',email:'',mobile_number:''});

  useEffect(() => {
    document.title = `Thank You | Your Friend My Friend`;
    document.getElementById('bodywrap').className='ordercomplete';

    const state = location.state;

    if (!state || !state.order_number) {
    navigate('/');
    return;
    }

    /* Start get order data */
    let formData = new FormData(); 
    formData.append('order_number', state.order_number);
    API.post('get_product_order_detail',formData)
      .then(response => {
        setLoading(false);
      if(response.data.status === false){
        
      }else{
        setInputs({
          id:response.data.data.id,
          order_number:response.data.data.order_number,
          name:response.data.data.name,
          email:response.data.data.email,
          mobile_number:response.data.data.mobile_number
        });
      }                  
    }).catch(error => {
       
    });  
   /* End get order data */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (
    <>
      <div className="container py-5">
        <div className="comple">
          <div className="row">
            <div className="col-md-12 order-first">
              <img
                src="/assests/images/modal-right.png"
                alt="modal-right"
                className="img-fluid"
              />
              <h3>Thank You</h3>
              <p>
                Thank you for your purchase—your order has been placed, and a confirmation email is on its way to your inbox! You will receive an order update in your email.
              </p>
            </div>
          </div>

          <div className="row d-flex align-items-center uio">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-0">
              <h3>{inputs.name}</h3>
              <p>
                {inputs.email}
                <br />
                {inputs.mobile_number}
              </p>
            </div>
            <div className="col-md-6 col-sm-6 col-6 text-end p-0 links">
              <div className="orak">
                #{inputs.order_number}
              </div>
              
            </div>
          </div>
            
            <div className="text-center mt-5">
              <Link className="btn brow-bu text-decoration-none" to="/">More from YFMF</Link>
            </div>
          


        </div>
      </div>
      {loading && (
     <div className="loadingClass">
      <img src={loader} alt="loader"/>
    </div>
     )}
    </>
  );
};

export default ThankYou;